/**
 * replace \n to <br>
 * \n 을 br 형태로 반환
 * e.g) 안녕\n하세요 => 안녕<br>하세요
 * @param text
 * @returns {string}
 */
export const getTextBreaks = (text = '') => {
  if (!text) {
    return ''
  }

  return text.replaceAll('\n', '<br>')
}
